import React from 'react';
import Select, { components } from 'react-select';
import { get } from 'lodash';

const { Option } = components;
/**
 * Customizable Options tag for react select
 * @param {*} props
 */
const IconOption = (props) => (
    <Option {...props}>
        {get(props, 'data.layout', get(props, 'data.label'))}
    </Option>
);
/**
 * Plan selection component
 * @param {*} param0
 */
const PlanSelect = ({
    serverOptions,
    value,
    changeEvent,
    className,
    placeholder,
}) => {
    return (
        <Select
            options={serverOptions}
            placeholder={placeholder}
            className={className}
            components={{
                Option: IconOption,
                IndicatorSeparator: () => null,
            }}
            onChange={(data) => {
                changeEvent && changeEvent(data);
            }}
            value={value}
        />
    );
};

/**
 * Special configuration model which shows an image , name and subtitle within the select element.
 * @param {*} ImagePath
 * @param {*} title
 * @param {*} subTitle
 */
export const flavourSelectModel = (
    title,
    userMinRange,
    UserMaxRange,
    subTitle,
    secondaryTitle,
    secondarySubTitle,
    amount,
    unit
) => {
    return (
        <>
            <div className="inf-select-items-wrapper inf-flavor-selection-main-wrapper">
                <div className="inf-select-items-in">
                    <div className="image-elm">
                        <i className="inf-selection-indicator inf-green-selection"></i>
                        <div className="profile-name inf-flavor-name">
                            <p>{title}</p>

                            <span className="inf-flavor-sub-text">
                                <>
                                    {UserMaxRange ? (
                                        <>
                                            {userMinRange} - {UserMaxRange}{' '}
                                            users recommended
                                        </>
                                    ) : (
                                        <>Above {userMinRange} users</>
                                    )}
                                </>
                            </span>

                            {subTitle && <span>{subTitle}</span>}
                        </div>
                    </div>
                </div>
                <div className="inf-select-items-wrapper-in">
                    {secondaryTitle && (
                        <div className="inf-select-core-wrapper">
                            <div className="image-elm">
                                <div className="profile-name inf-select-core-name">
                                    <p>{secondaryTitle}</p>
                                    {secondarySubTitle && (
                                        <span>{secondarySubTitle}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {amount && (
                        <div className="inf-select-flavor-storage">
                            <div className="image-elm">
                                <div className="profile-name">
                                    <p>${amount}</p>
                                    {unit && <span>/{unit}</span>}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default PlanSelect;
